export default __webpack_public_path__ + "static/media/Home.49972c0f.png";